module.exports = __webpack_public_path__ + "img/difficulty_3.c352e6c6.png";